import React from "react";
import DataTable from "react-data-table-component";
const TableComponent = () => {
  const data = [
    { id: 1, name: "John Doe", email: "john@example.com", age: 28 },
    { id: 2, name: "Jane Smith", email: "jane@example.com", age: 24 },
    { id: 3, name: "Sam Johnson", email: "sam@example.com", age: 32 },
  ];

  const columns = [
    { name: "ID", selector: (row) => row.id, sortable: true },
    { name: "Name", selector: (row) => row.name, sortable: true },
    { name: "Email", selector: (row) => row.email },
    { name: "Age", selector: (row) => row.age, sortable: true },
  ];

  // const customStyles = {
  //   rows: {
  //     style: {
  //       fontSize: "16px",
  //       backgroundColor: "#f8f9fa", // Light grey like Bootstrap tables
  //       borderBottom: "1px solid #dee2e6",
  //     },
  //   },
  //   headCells: {
  //     style: {
  //       backgroundColor: "#343a40",
  //       color: "#fff",
  //       fontSize: "18px",
  //     },
  //   },
  // };

  return (
    <div className="container mt-4">
      <h2 className="text-center mb-3">React Bootstrap Data Table</h2>
      <div className="card">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={data}
            // customStyles={customStyles}
            pagination
            highlightOnHover
            dense
          />
        </div>
      </div>
    </div>
  );
};

export default TableComponent;
